import { Text } from "@fluentui/react";

export const PanelBodyCreate = () => {
  return (
    <Text>
      You need to create an ingestion source by defining the type of ingestion source
      then introduce the container URL and the value of the SAS Token or Managed
      Identity.
    </Text>
  );
};
